import styled, { css } from 'styled-components';
import { getBorderColor, themeGet } from '@magalu/stereo-ui-styles';
import Box from '../Box';
export const Container = styled(Box)`
  display: flex;
  align-items: center;
  cursor: pointer;

  label {
    margin-right: ${props => themeGet('space.2')(props)}px;

    ${({
  desktopMode
}) => desktopMode && css`
        font-size: ${props => themeGet('fontSizes.1')(props)}px;
      `};
  }

  select {
    appearance: none;
    display: block;
    background-color: ${props => themeGet('colors.white')(props)};
    cursor: pointer;
    border: 1px solid ${props => getBorderColor('base')(props)};
    border-radius: ${props => themeGet('radii.default')(props)};

    ${({
  desktopMode
}) => desktopMode ? css`
            font-size: ${props => themeGet('fontSizes.1')(props)}px;
            padding: 8px 32px 8px 12px;
          ` : css`
            width: 100%;
            padding: 16px 32px 16px 12px;
            border-radius: 4px;
          `};

    &:focus {
      outline: none;
      background: ${props => themeGet('baseColors.wildsand.base')(props)};
    }
    ::-ms-expand {
      display: none;
    }
  }

  svg {
    outline: none;
    pointer-events: none;

    flex: 0 0 auto;
    margin-left: -32px;
  }
`;